import {
  getSubOrderDescRequest,
  getSubOrderStepRequest,
  requestSuborderApprove,
  requestRetrySuborderApprove,
  getSubOrderLogRequest,
  requestRemindSuborderApprove,
  requestWorkorderWithdraw
} from '../../../api/api'
import {getUrl} from "../../../utils/global/geturl";  // 导入封装后的axios请求
import ajax from "../../../api/ajax"


const state = {}

const getters = {}

const actions = {
  async getSuborderDesc ({commit}, params) {
    return getSubOrderDescRequest(getUrl(params)).then(response => response)
  },
  async getSuborderStep ({commit}, params) {
    return getSubOrderStepRequest(getUrl(params)).then(response => response)
  },
  async suborderApprove ({commit}, params) {
    return requestSuborderApprove(params).then(response => response)
  },
  async retrySuborderApprove ({commit}, params) {
    return requestRetrySuborderApprove(params).then(response => response)
  },
  async getSubOrderLog ({commit}, params) {
    return getSubOrderLogRequest(getUrl(params)).then(response => response)
  },
  async remindSuborderApprove ({commit}, params) {
    return requestRemindSuborderApprove(params).then(response => response)
  },
  async workorderWithdraw ({commit}, params) {
    return requestWorkorderWithdraw(params).then(response => response)
  },
};

const mutations = {}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/suborder/suborder.js